<template>
    <div class="nav-footer" v-if="data">
        <ul class="nav-footer__list">
            <li
                :key="index"
                class="nav-footer__item"
                v-for="(item, index) in data"
            >
                <a
                    :href="item.link"
                    v-html="item.name"
                    class="nav-footer__link"
                    :target="item.blank ? '_blank' : false"
                ></a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'nav-footer',
    props: {
        data: Array
    }
}
</script>

<style lang="scss">
.nav-footer {
    & + & {
        margin-top: 44px;

        @include breakpoint (laptop) {
            margin-top: 32px;
        }
    }

    &__link {
        color: $token-colors-link-dark-default;
        font-size: 16px;
        text-decoration: none;
        transition: color $transition;

        &:hover {
            color: $token-colors-link-dark-hover;
        }

        &:active {
            color: $token-colors-link-dark-active;
        }
    }

    &__list {
        display: flex;
        flex-wrap: wrap;
        margin-left: -$token-spacers-s;
        margin-right: -$token-spacers-s;
        margin-top: -$token-spacers-xxs;

        @include breakpoint (laptop) {
            margin-left: -$token-spacers-xxs;
            margin-right: -$token-spacers-xxs;
        }
    }

    &__item {
        padding: 0 $token-spacers-s;
        margin-top: $token-spacers-xxs;

        @include breakpoint (laptop) {
            padding: 0 $token-spacers-xxs;
        }
    }
}

</style>
